var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500", lazy: "" },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            [
              _c("img", {
                staticClass: "align-center cursor-pointer",
                attrs: {
                  height: "38",
                  width: "38",
                  src: "/static/Quickbooks-Logo.png"
                }
              }),
              _vm._v(" "),
              _c("v-toolbar-title", [
                _vm._v(
                  "\n        Simplify Accounting by Using Quickbooks\n      "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("div", { staticClass: "pa-3" }, [
            _vm._v(
              "\n      Did you know " +
                _vm._s(_vm.$t("site-title")) +
                " can create invoices and billable expenses in Quickbooks for you, without\n      leaving this screen? Using all the details from the load created in the planner and the\n      driver's status updates along the way, " +
                _vm._s(_vm.$t("site-title")) +
                " can export all the customer, origin,\n      destination, and freight information.\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pa-3" }, [
            _vm._v(
              "Check it out now by connecting to Quickbooks in your company's profile!\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "accent", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.openDialog = false
                    }
                  }
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "accent",
                    to:
                      "/companies/" +
                      _vm.invoicingCompany.id +
                      "/profile#quickbooks"
                  }
                },
                [_vm._v("\n        Setup Quickbooks\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b3e4ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3e4ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qb/InfoDialog.vue
// module id = null
// module chunks = 